<template>
    <div class="filemanager" :class="{ 'filemanager--uploading': isCurrentlyUploading }">
        <div class="filemanager__inner">
            <app-controlhead
                :title="
                    getFilemanagerFilesView === 'images' ? 'Bildersammlung' : 'Dokumentensammlung'
                "
                :help="
                    getFilemanagerFilesView === 'images'
                        ? $helpers.uiText('R001')
                        : $helpers.uiText('R003')
                "
                :show-close="true"
                :show-remove="false"
                :show-save="false"
                :show-global="false"
                @close="closeFilemanager"
            ></app-controlhead>

            <div class="filemanager__view" :class="'filemanager__view--' + getFilemanagerFilesView">
                <ul class="filetab__list">
                    <li
                        v-for="(folder__value, folder__key) in getFilemanagerFilesView ===
                        'documents'
                            ? ['uploads']
                            : ['uploads', 'media']"
                        :key="folder__key"
                        class="filetab__list-element"
                        :class="{ 'filetab__list-element--current': currentTab == folder__value }"
                    >
                        <a
                            href="#"
                            @click.prevent="currentTab = folder__value"
                            class="filetab__list-link"
                        >
                            <template
                                v-if="
                                    getFilemanagerFilesView == 'images' &&
                                        folder__value == 'uploads'
                                "
                                >Eigene Bilder</template
                            >
                            <template
                                v-else-if="
                                    getFilemanagerFilesView == 'documents' &&
                                        folder__value == 'uploads'
                                "
                                >Eigene Dokumente</template
                            >
                            <template
                                v-else-if="
                                    getFilemanagerFilesView == 'images' && folder__value == 'media'
                                "
                                >Bilderpool</template
                            >
                            <template
                                v-else-if="
                                    getFilemanagerFilesView == 'documents' &&
                                        folder__value == 'media'
                                "
                                >Dokumentenpool</template
                            >
                        </a>
                    </li>
                </ul>
                <template v-for="(folder__value, folder__key) in ['uploads', 'media']">
                    <div
                        :key="folder__key"
                        v-if="folder__value == currentTab"
                        class="filetab__tab"
                        :class="'filetab__tab--' + getFilemanagerFilesView"
                    >
                        <p
                            class="filelist__note"
                            v-if="folder__value === 'uploads'"
                            v-html="
                                getFilemanagerFilesView === 'images'
                                    ? $helpers.uiText('R081')
                                    : $helpers
                                          .uiText('R082')
                                          .replace(
                                              '%ACCEPTED%',
                                              getFilemanagerData.accept.toUpperCase()
                                          )
                                          .replace(/[.]/g, '')
                                          .replace(/[,]/g, ', ')
                            "
                        ></p>

                        <ul class="filelist" :class="'filelist--' + getFilemanagerFilesView">
                            <li
                                class="filelist__element fileupload"
                                v-if="folder__value === 'uploads'"
                                :class="
                                    'filelist__element--' +
                                        getFilemanagerFilesView +
                                        ' fileupload--' +
                                        getFilemanagerFilesView
                                "
                            >
                                <label
                                    class="fileupload__label"
                                    :class="'fileupload__label--' + getFilemanagerFilesView"
                                    v-tooltip="'Neue Datei hochladen'"
                                >
                                    <input
                                        class="fileupload__input"
                                        :class="'fileupload__input--' + getFilemanagerFilesView"
                                        type="file"
                                        @change="
                                            uploadInFilemanager({
                                                folder: folder__value,
                                                event: $event
                                            }).catch(() => {})
                                        "
                                        :accept="getAcceptedFilesInFilemanager"
                                        multiple
                                    />
                                </label>
                            </li>
                            <li
                                class="filelist__element file"
                                :class="
                                    'filelist__element--' +
                                        getFilemanagerFilesView +
                                        ' file--' +
                                        getFilemanagerFilesView
                                "
                                v-for="files__value in getRelevantFiles(folder__value)"
                                :key="files__value.id"
                            >
                                <div
                                    :class="[
                                        {
                                            'file__preview--is-active': isActiveFile(
                                                files__value.id
                                            )
                                        },
                                        'file__preview file__preview--' +
                                            getFileExtension(files__value.id) +
                                            ' file__preview--type-' +
                                            getFilemanagerFilesView
                                    ]"
                                    :style="{
                                        backgroundImage:
                                            'url(' +
                                            generateMediaUrl({
                                                id: files__value.id,
                                                w: 200,
                                                h: 200
                                            }) +
                                            ')'
                                    }"
                                    v-if="getFilemanagerFilesView === 'images'"
                                >
                                    <a
                                        v-on:click.prevent="toggleActiveFile(files__value.id)"
                                        href="#"
                                        class="file__use"
                                        >Verwenden</a
                                    >
                                    <a
                                        v-on:click.prevent="edit(files__value.id)"
                                        href="#"
                                        class="file__edit"
                                        >Ansehen/Bearbeiten</a
                                    >
                                </div>
                                <div
                                    :class="[
                                        {
                                            'file__preview--is-active': isActiveFile(
                                                files__value.id
                                            )
                                        },
                                        'file__preview file__preview--' +
                                            getFileExtension(files__value.id) +
                                            ' file__preview--type-' +
                                            getFilemanagerFilesView
                                    ]"
                                    v-if="getFilemanagerFilesView === 'documents'"
                                >
                                    <span class="file__pseudo-checkbox"></span>
                                    <span class="file__icon"></span>
                                    <span class="file__label">Dateiname</span>
                                    <span class="file__name">{{ files__value.filename }}</span>
                                    <a
                                        v-on:click.prevent="toggleActiveFile(files__value.id)"
                                        href="#"
                                        class="file__use"
                                        >Verwenden</a
                                    >
                                    <a
                                        v-on:click.prevent="edit(files__value.id)"
                                        href="#"
                                        class="file__edit"
                                        >Ansehen/Bearbeiten</a
                                    >
                                </div>
                            </li>
                        </ul>
                    </div>
                </template>
            </div>
        </div>
        <div class="filemanager__buttons">
            <a
                v-if="filesSelected"
                v-on:click.prevent="saveAndCloseFilemanager()"
                href="#"
                class="button button--icon-checkmark filemanager__use"
            >
                {{ getFilemanagerFilesView === 'images' ? 'Bild einfügen' : 'Datei einfügen' }}
            </a>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Controlhead from '@/components/assorted/Controlhead';

export default {
    data() {
        return {
            currentTab: 'uploads'
        };
    },
    components: {
        'app-controlhead': Controlhead
    },
    methods: {
        ...mapActions([
            'routeAddQuery',
            'toggleActiveFile',
            'closeFilemanager',
            'saveAndCloseFilemanager',
            'uploadInFilemanager'
        ]),
        ...mapMutations([]),
        async edit(id) {
            await this.routeAddQuery({
                fileeditor: 1,
                fileeditor_file_id: id
            });
        }
    },
    computed: {
        ...mapGetters([
            'filesSelected',
            'getFiles',
            'getFilemanagerData',
            'isActiveFile',
            'getRelevantFiles',
            'getAcceptedFilesInFilemanager',
            'getFilemanagerFilesView',
            'getMultiple',
            'generateMediaUrl',
            'fileIsImage',
            'getFileExtension',
            'isCurrentlyUploading'
        ])
    },
    created() {}
};
</script>
